import { AuthContext } from "context/AuthContext";
import { arrayRemove, doc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import { PostProps } from "pages/home";
import { useContext } from "react";
import { toast } from "react-toastify";
import styles from "./Comment.module.scss";
import useTranslation from "hooks/useTranslation";

export interface CommentProps {
    comment: string;
    createdAt: string;
    email: string;
    uid: string;
}

interface CommentBoxProps {
    data: CommentProps;
    post: PostProps;
}
export default function CommentBox({ data, post }: CommentBoxProps) {
    const { user } = useContext(AuthContext);
    const t = useTranslation();
    const handleDeleteComment = async () => {
        if (post) {
            try {
                const postRef = doc(db, "posts", post.id);
                await updateDoc(postRef, {
                    comments: arrayRemove(data),
                });

                toast.success("댓글 삭제 성공");
            } catch (error) {
                console.error(error);
                toast.error("댓글 삭제 실패");
            }
        }
    };
    return (
        <div key={data.createdAt} className={styles.comment}>
            <div className={styles.comment__borderBox}>
                <div className={styles.comment__imgBox}>
                    <div className={styles.comment__flexBox}>
                        <img src={`/logo192.png`} alt="profile" />
                        <div className={styles.comment__email}>{data.email}</div>
                        <div className={styles.comment__createdAt}>{data.createdAt}</div>
                    </div>
                </div>
                <div className={styles.comment__content}>{data.comment}</div>
                {post.uid === user?.uid && (
                    <div className={styles.comment__submitDiv}>
                        <button
                            type="button"
                            className="comment__delete-btn"
                            onClick={handleDeleteComment}
                        >
                            {t("BUTTON_DELETE")}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
